// Chart Theme — Moon color scheme
// Source: Figma M⌝ DesignSystem — Charts (Pie, Bar, Line)
//
// Chart colorway uses the Platform scale from light to bold,
// giving a cohesive purple gradient that scales from 2 to 10+ series.
// Order: L10 -> L200 -> L400 -> L600 -> L800 -> B10 -> B100 -> B300 -> B500 -> B600
/** Map series palette + emphasis/select colors (shared with map.echart and other geo configs). */
export const mapColors = ['#E1E2FF', '#787CFC', '#2F3490'] as const;
export const emphasisColor = '#454BD1';
export const selectColor = '#D46944';

/** Mercury chart colorway (L10 → B600). Re-exported for non-ECharts widgets
 * (custom legends, plain divs, …) that need to mirror the same palette. */
export const mercuryColorwayPalette = [
  '#E1E2FF', // L10
  '#9498FF', // L200
  '#787CFC', // L400
  '#676BEB', // L600
  '#5B60E7', // L800
  '#4D52CF', // B10
  '#3F44BF', // B100
  '#3035AB', // B300
  '#262B92', // B500
  '#2F3490', // B600
] as const;

const mercuryColorway = {
  name: 'mercuryColorway',
  props: {
    color: [...mercuryColorwayPalette],
    textStyle: {
      color: 'var(--mantine-color-text)',
      fontFamily: 'Inter, sans-serif',
      fontSize: 12,
    },
    bar: {
      label: {
        color: 'var(--mantine-color-text)',
        fontSize: 12,
      },
      itemStyle: {
        borderRadius: [2, 2, 0, 0],
      },
    },
    pie: {
      label: {
        color: 'var(--mantine-color-text)',
        fontSize: 12,
      },
    },
    line: {
      lineStyle: {
        width: 2,
      },
      symbolSize: 6,
      label: {
        color: 'var(--mantine-color-text)',
        fontSize: 10,
      },
    },
    title: {
      left: -5,
      textStyle: {
        color: 'var(--mantine-color-text)',
        fontSize: 16,
        fontWeight: 600,
        overflow: 'break',
        fontFamily: 'Inter, sans-serif',
      },
    },
    legend: {
      textStyle: {
        color: 'var(--mantine-color-text)',
        fontSize: 12,
        fontFamily: 'Inter, sans-serif',
      },
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 12,
    },
    categoryAxis: {
      axisLine: {
        lineStyle: {
          color: 'var(--ds-border-line, #D7D7D7)',
        },
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: 'var(--mantine-color-text)',
        fontSize: 11,
      },
      splitLine: {
        lineStyle: {
          color: 'var(--ds-grey-100, #EBEFF2)',
        },
      },
    },
    valueAxis: {
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: 'var(--mantine-color-text)',
        fontSize: 11,
      },
      splitLine: {
        lineStyle: {
          color: 'var(--ds-grey-100, #EBEFF2)',
        },
      },
    },
    tooltip: {
      backgroundColor: 'var(--ds-surface, rgba(255, 255, 255, 0.95))',
      borderColor: 'var(--ds-border-line, #D7D7D7)',
      borderWidth: 1,
      textStyle: {
        color: 'var(--ds-font-color, #333333)',
        fontSize: 12,
        fontFamily: 'Inter, sans-serif',
      },
    },
  },
};

export const themes = [mercuryColorway];
